@use "sass:map";
@use '../../sass/theme';

:host([disabled]) {
  pointer-events: none;
  touch-action: none;
}
:host([disabled='false']) {
  pointer-events: auto;
  touch-action: auto;
}

$variants: primary, secondary, success, info, warning, danger, low, high;
// todo - should we use the jds-theme-fs here?
$font-sizes: (
  xxs: 14px,
  xs: 16px,
  sm: 20px,
  md: 24px,
  lg: 32px,
  xl: 38px
);

$line-heights: (
  xxs: 1,
  xs: 1,
  sm: 1.2,
  md: 1.2,
  lg: 1.2,
  xl: 1.5
);

@mixin material-icon {
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}

@mixin get-variants($withButtonStates: false) {
  @each $variant in $variants {
    &.#{$variant} {
      color: var(--jui-#{$variant}-color);

      @if $withButtonStates {
        &:hover {
          color: var(--jui-#{$variant}-color--darker);
        }

        &:active {
          color: var(--jui-#{$variant}-color--darkest);
        }
      }
    }
    &.current {
      color: currentColor;
      @if $withButtonStates {
        &:hover {
          opacity: 0.8;
        }
        &:active {
          opacity: 0.7;
        }
      }
    }
  }
}

@mixin get-sizes {
  @each $name, $font-size in $font-sizes {
    &.#{$name} {
      font-size: #{$font-size};
      line-height: map.get($line-heights, $name);
    }
  }
}

:host {
  .material-icons {
    font-family: 'Material Icons';
    @include material-icon;
  }
  .material-icons-outlined {
    font-family: 'Material Icons Outlined';
    @include material-icon;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;

    &:disabled {
      opacity: 0.7;
      pointer-events: none;
      transition: background-color var(--jui-transition-out), color var(--jui-transition-out);
    }

    @include get-variants(true);
    @include get-sizes;
  }

  span {
    cursor: default;
    padding: 0;
    margin: 0;

    @include get-variants;
    @include get-sizes;
  }
}
